import { UIUtil } from "../../Form/CustomizationContexts/HelperFunctionContext/UIUtil/UIUtil";
import { getViewModel } from "../Store/FormViewModel";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

export class CustomNormalizationHelper {
    private readonly form: IForm;

    public constructor(form: IForm) {
        this.form = form;
    }

    public isFillAutoFieldsFeatureEnabled() {
        const viewModelNode = this.form.store.getState().viewModel[this.form.settings.formRoot];
        return (
            viewModelNode != undefined &&
            getViewModel(viewModelNode)?.normalizationSource === "server" &&
            !this.form.settings.disableFlangRulesForEnableAutoFieldFeature
        );
    }

    public async fillAutoFieldsWithAutoValuesAndReload(
        pathPrefixes: AbsoluteModelPath[],
        forceReload: boolean = false
    ): Promise<void> {
        const uiUtil = new UIUtil(this.form.settings.theme);
        await uiUtil.executeLongOperation(
            { title: "Включение авторасчета", modalSpecialCase: "InfiniteProcess", allowCancel: false },
            async p => {
                await this.form.customNormalize("formulas", pathPrefixes, forceReload);
                p.setFinishValue(100);
            }
        );
    }
}
